/* unplugin-vue-components disabled */import { render } from "./serviceContent.vue?vue&type=template&id=409c167c&scoped=true"
import script from "./serviceContent.vue?vue&type=script&lang=js"
export * from "./serviceContent.vue?vue&type=script&lang=js"

import "./serviceContent.vue?vue&type=style&index=0&id=409c167c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.15_webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-409c167c"]])

export default __exports__